var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffersarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 49,
    viewBox: "0 0 143 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.938 48.2112L127.956 27.2409C126.714 25.5023 126.714 23.1667 127.956 21.4281L142.938 0.455482L5.78906 0.455482C3.02763 0.455482 0.789062 2.69406 0.789062 5.45548V43.2112C0.789062 45.9726 3.02763 48.2112 5.78906 48.2112L142.938 48.2112Z",
    fill: "#2d5644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersarrow);
export default __webpack_public_path__ + "static/media/offersarrow.a8c7d504faa453d59d75337244b5c2ff.svg";
export { ForwardRef as ReactComponent };